import React from "react";
import MenuItem from "./MenuItem";
import GetUser from "../../../utils/UserFunctions/GetUser";
import injectSheet from "react-jss";
import { ViewType, ListType } from "../../../utils/Enums";
import styles from "./NavMenusStyles"; // Import styles

function Editmenu(props) {
  const { classes, hideHeader, toggleSubmenu, toggleMobileMenu } = props;
  const allViews = GetUser().allViews;
  const visasamv = !GetUser().visaEjSamvArr;

  const views = allViews.filter(
    (view) =>
      view !== ViewType.AttSkapa &&
      view !== ViewType.VisaArkiverade &&
      view !== ViewType.VisaPågående &&
      view !== ViewType.VisaGodkända &&
      view !== ViewType.VisaSlutförda
  );
  const viewsSamv = allViews.filter(
    (view) =>
      view === ViewType.EjInskickade ||
      view === ViewType.NekadeSomSkaKompletteras ||
      view === ViewType.InskickadeSomSkaGodkännas
  );
  if (viewsSamv.length > 0 && visasamv) {
    viewsSamv.push(ViewType.Godkända);
  }
  const viewsAvd = allViews.filter(
    (view) =>
      view === ViewType.AttGodkänna ||
      view === ViewType.AttStarta ||
      view === ViewType.AttKontrollera ||
      view === ViewType.AttSlutrapportera ||
      view === ViewType.AttSkickaTillStartare ||
      view === ViewType.RedigeraStartade
  );

  return (
    <div className={classes.navmenu}>
      {!hideHeader && <h2>Hantera</h2>}
      <h4>Mina arrangemang</h4>
      {views.map((view, i) => (
        <MenuItem
          toggleSubmenu={toggleSubmenu}
          toggleMobileMenu={toggleMobileMenu}
          view={view}
          listtype={ListType.User}
          key={i}
        />
      ))}
      {viewsSamv.length === 0 || !visasamv ? null : (
        <>
          <h4>Mina organisationers arrangemang</h4>
          {viewsSamv.map((view, i) => (
            <MenuItem
              toggleSubmenu={toggleSubmenu}
              toggleMobileMenu={toggleMobileMenu}
              view={view}
              listtype={ListType.Samverkanspart}
              key={i}
            />
          ))}
        </>
      )}
      {viewsAvd.length === 0 ? null : <h4>Avdelningens arrangemang</h4>}
      {viewsAvd.map((view, i) => (
        <MenuItem
          toggleSubmenu={toggleSubmenu}
          toggleMobileMenu={toggleMobileMenu}
          view={view}
          listtype={ListType.Avdelning}
          key={i}
        />
      ))}
    </div>
  );
}
export default injectSheet(styles)(Editmenu);
